<template>
 <div class="fixed hidden ml-4 space-y-4 lg:block" style="top: 50%;transform: translateY(-50%);">
    <template v-for="look in looks">
        <div class="">
          <button
            @click.prevent="$emit('change', { key: 'look', value: look.id })"
            class="inline-flex items-center justify-center w-10 h-10 p-3 font-bold rounded-full cursor-pointer ring-4 ring-white"
            :class="[
                state.look === look.id
                  ? 'bg-white text-teal-50'
                  : 'text-white bg-green-500 hover:bg-green-300',
              ]">
            {{ look.title }}
          </button>
        </div>
    </template>
</div>
</template>
<script>
export default {
  props: {
    state: {
      type: Object,
      default: null
    }
  },

  data () {
      return {
          looks: [
              {
                  title: '1',
                  id: 'look_1'
              },
              {
                  title: '2',
                  id: 'look_2'
              },
              {
                  title: '3',
                  id: 'look_3'
              },
              {
                  title: '4',
                  id: 'look_4'
              },
              {
                  title: '5',
                  id: 'look_5'
              },
              {
                  title: '6',
                  id: 'look_6'
              }
          ]
      }
  }

};
</script>
